import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ChangePasswordComponent } from '@app/auth/components/change-password/change-password.component';
import { TranslateService } from '@ngx-translate/core';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import storageService from '@shared/storage/storageService';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent implements OnInit {

  sidenav_opened = false;
  selectedLanguage: string;
  subscription: any;
  isComponent: any;
  constructor( private broadCast: BroadCastServiceService,
    private router: Router,
    public dialog: MatDialog,
		private translate: TranslateService
    ) { }

  ngOnInit(): void {
    this.setLanguage();
    this.subscription = this.broadCast.getMessage().subscribe((message) => {
      if (message) {
        this.isComponent = message;
        console.log("this.isComponent",this.isComponent);
      }
    });
  }

  setLanguage() {
		this.selectedLanguage = storageService.getItem("language");
		this.translate.use(this.selectedLanguage);
	}
  
  logout() {
    storageService.clearItem("token");
    storageService.clearItem("currentUser");
    storageService.clearItem("userId");
    this.router.navigate(["landing-page"]);
  }

  openChangePwdModel() {
    this.dialog.open(ChangePasswordComponent);
  }

  onClick(routeString){
    this.router.navigate([routeString]);
  }

  onMyAppoinment(routeStr){
    this.router.navigate([routeStr]);
  }


}
